import { ControlProps } from 'nuka-carousel'
import { sendCarouselPromoEvent } from '@src/utils/analytics/carouselAnalytics'
import {
  CarouselProduct,
  CarouselProductTypes,
} from './DynamicProductCardTypes'

export type ProductCarouselControlProps = Pick<
  ControlProps,
  | 'currentSlide'
  | 'slidesToShow'
  | 'slideCount'
  | 'previousSlide'
  | 'nextSlide'
  | 'slidesToScroll'
>

/**
 * Invokes nuka-carousel slide movement actions paired with our carousel analytics tracking.
 * nuka-carousel provides really good, extensible functions and data on current carousel state.
 * As well as navigation/traversal of the carousel to different states/postions.
 *
 * This handles those next and previous navigation actions + analytics reporting for them.
 *
 * @param carouselProps
 * @param products
 * @param direction
 * @param creativeSlot
 * @param pageType
 * @param pageTypeDetails
 */
export const handleSlideMovement = (
  carouselProps: ProductCarouselControlProps,
  products: CarouselProduct[],
  direction: 'next' | 'prev',
  creativeSlot: string,
  carouselType: CarouselProductTypes,
  pageType?: string | null,
  pageTypeDetails?: string | null
) => {
  const currSlide = carouselProps.currentSlide
  const slidesScrolled = carouselProps.slidesToScroll
  const slidesVisible = carouselProps.slidesToShow

  // These values need added or subtracted from based on if it's a previous vs next operation.
  // So we set them to some sensible defaults as lets and then update them based on action.
  let inViewIndexStart = 0
  let inViewIndexEnd = slidesVisible

  if (direction === 'next') {
    inViewIndexStart = currSlide + slidesScrolled
    inViewIndexEnd = inViewIndexStart + slidesVisible

    carouselProps.nextSlide()
  }

  if (direction === 'prev') {
    inViewIndexStart = currSlide - slidesScrolled
    inViewIndexEnd = inViewIndexStart + slidesVisible

    carouselProps.previousSlide()
  }

  const slicedVisible: CarouselProduct[] = products
    .slice(inViewIndexStart, inViewIndexEnd)
    .map((product, index) => ({
      ...product,
      analyticsPosition: inViewIndexStart + index + 1,
    }))

  sendCarouselPromoEvent({
    creativeSlot,
    carouselType,
    promoItemId: pageType,
    promoItemName: pageTypeDetails,
    products: slicedVisible,
  })
}
